import { jsx } from 'react/jsx-runtime';
import { ReactComponent as SvgErrorTriangle } from './svg/error-triangle.svg.js';

/**
 * @deprecated - use AlertTriangle.
 *
 * @param {boolean} legacyBoundingBox - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {number} size - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {string} title - (optional) will be applied as `aria-label` unless an `aria-label` is explicitly set.
 */
const ErrorTriangle = (props) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { title, size: _size, legacyBoundingBox: _legacyBoundingBox, ...rest } = props;
    return (jsx(SvgErrorTriangle, { viewBox: "0 0 24 24", "aria-label": title, role: "img", ...rest, width: 24, height: 24, "data-pp-icon": "ErrorTriangle" }));
};

export { ErrorTriangle as default };
//# sourceMappingURL=ErrorTriangle.js.map
